import type { CommonStylesPalette } from '../types.d';

export const playPauseCarouselStyle = ({ palette = {} as CommonStylesPalette }) => ({
  PlayPauseButtons: {
    position: 'absolute',
    bottom: '13.5px',
    '& span': {
      color: palette.themePrimary,
    },
    '& button:hover': { backgroundColor: 'transparent' },
    '&:focus-within::after': {
      content: '""',
      position: 'absolute',
      inset: '2px',
      border: '1px solid transparent',
      outline: 'rgb(96, 94, 92) solid 1px',
      zIndex: '1',
      width: '28px',
      height: '28px',
      pointerEvents: 'none',
    },
  },
  PlayPauseButtonsContainer: {
    '& .carousel-wrapper': {
      position: 'relative',
    },
    '& .new-carousel-navigation ~ .carousel-injected-controls.hidden$PlayPauseButtons': {
      left: '221px',
      display: 'initial !important',
    },
    '& .new-carousel-navigation-v2 ~ .carousel-injected-controls.hidden$PlayPauseButtons': {
      left: '294px',
      display: 'initial !important',
    },
    '& .boost-carousel ~ .carousel-injected-controls.hidden$PlayPauseButtons': {
      left: '366px',
      display: 'initial !important',
    },
    '& .boost-carousel-new-support ~ .carousel-injected-controls.hidden$PlayPauseButtons': {
      left: '500px',
      display: 'initial !important',
    },
    '& .new-carousel-navigation-mma ~ .carousel-injected-controls.hidden$PlayPauseButtons': {
      left: '156px',
      display: 'initial !important',
    },
  },
});
